import styled from "@emotion/styled";

export const HomeContainer = styled.div`
  overflow-y: scroll;
  width: 100%;
  height: 100%;
  max-height: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px 24px;
`;
